import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { useTheme } from "@material-ui/styles";

import CustomSelect from "../../common/CustomSelect";
import { setPaginationInfo } from "../../../store/transcripts/transcriptsActions";
import { setTheme } from "../../../store/theme/themeActions";
import storageService from "../../../services/storage.service";
import config from "../../../config";

import {
  Dialog,
  DialogContent,
  CloseButton,
  IOSSwitch,
  Divider
} from "./styles";

const options = [
  {
    label: '6',
    value: 6
  },
  {
    label: '10',
    value: 10
  },
  {
    label: '15',
    value: 15
  }
];

const SettingsDialog = (props) => {
  const { isShow, setIsShow, paginationInfo, setTheme, setPaginationInfo } = props;
  const theme = useTheme();
  
  const handleChange = (e) => {
    const currentTheme = e.target.checked ? 'light' : 'dark'
    setTheme(currentTheme)
    storageService.setItem(config.THEME, currentTheme)
  }

  return (
    <Dialog
      open={isShow}
      onClose={() => setIsShow(false)}
    >
      <DialogContent>
        <h4>Settings</h4>
        <div className="setting-block">
          <div className="theme-change">
            <img src={`/static/img/icons/moon--${theme.name}.svg`} alt="moon"/>
            <IOSSwitch
              checked={theme.name === 'light'}
              onChange={handleChange}
            />
            <img src={`/static/img/icons/sun--${theme.name}.svg`} alt="sun"/>
          </div>
        </div>
        <Divider/>
        <div className="setting-block">
          <p className="title">
            Audio Transcripts
          </p>
          <div className="input">
            <p className="label">
              Transcripts per page:
            </p>
            <CustomSelect
              value={paginationInfo.perPage}
              options={options}
              onChange={(value) => setPaginationInfo({...paginationInfo, perPage: value})}
            />
          </div>
        </div>
      </DialogContent>
      <CloseButton className="close-icon" onClick={() => setIsShow(false)}>
        X
      </CloseButton>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  viewMode: state.transcriptsReducer.viewMode,
  paginationInfo: state.transcriptsReducer.paginationInfo,
});

export default connect(mapStateToProps, {setTheme, setPaginationInfo})(withRouter(SettingsDialog));
